<div class="example-container">
  <div class="filter-row">
    <mat-form-field class="search-input">
      <input placeholder="Filter"
        matInput
        (keyup)="filter($event)">
      </mat-form-field>
    </div>

    <form [formGroup]="productsForm" autocomplete="off" class="products-form">
      <ng-container formArrayName="productRows">
        <table mat-table
          matSort
          [dataSource]="dataSource"
          class="mat-elevation-z8 mat-table-custom"
          id="kpiproducthierarchy">

          <ng-container matColumnDef="LineOfBusiness">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="LineOfBusiness" class="col-line-of-business">Line of Business</th>
            <td mat-cell *matCellDef="let element" class="col-line-of-business">
              <div [innerHTML]="element.LineOfBusiness"></div>
            </td>
          </ng-container>

          <ng-container matColumnDef="AssetType">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="AssetType" class="col-asset-type">Asset Type</th>
            <td mat-cell *matCellDef="let element" class="col-asset-type">
              <div [innerHTML]="element.AssetType"></div>
            </td>
          </ng-container>

          <ng-container matColumnDef="KpiProductHierarchyId">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="KpiProductHierarchyId" class="col-hierarchy-id"> Product hierarchy ID </th>
            <td mat-cell *matCellDef="let element" class="col-hierarchy-id">
              <div [innerHTML]="element.KpiProductHierarchyId"></div>
            </td>
          </ng-container>

          <ng-container matColumnDef="ProductHierarchyDescription">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="ProductHierarchyDescription" class="col-description"> Product Name (Global) </th>
            <td mat-cell *matCellDef="let element; let i = index" class="col-description">
              <div [innerHTML]="element.ProductHierarchyDescription"></div>
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="col-actions">Actions</th>
            <td mat-cell *matCellDef="let element; let i = index" class="col-actions">
              <button mat-icon-button
                matTooltip="Get Product History"
                (click)="onGetHistory(element)">
                <mat-icon class="actionButtons">history</mat-icon>
              </button>
                        </td>
                    </ng-container>

                    <tr mat-header-row class="tableheader" *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
                    <tr mat-row *matRowDef="let element; let i = index; columns: columnsToDisplay;"
                      [attr.data-product-id]="element.KpiProductHierarchyId"></tr>
                  </table>
                </ng-container>
              </form>
            </div>